module.exports = __webpack_public_path__ + "img/8.14e439c9.svg";